import Item from './Item';
import Root from './Root';

const Breadcrumb = {
  Root,
  Item,
};

export default Breadcrumb;
